<template>
    <div :class="['nav-container', { 'bg-black': $route.name == 'homepage' }]">
        <b-navbar transparent id="custom-nav">
            <template slot="brand">
                <b-navbar-item
                    class="logo"
                    tag="router-link"
                    :to="{ name: 'home' }"
                >
                    <img src="@/assets/images/logo.png" alt="logo" />
                    <span style="font-size: 5px">v-6</span>
                </b-navbar-item>
            </template>
            <template slot="start">
                <!-- <b-navbar-item
                    v-if="
                        $store.state.user.token &&
                        !$store.state.userData.is_updated
                    "
                    tag="router-link"
                    :to="{ name: 'verify-data' }"
                >
                    <span class="font-apercu-bold">{{
                        $t("Update your account")
                    }}</span>
                </b-navbar-item> -->
                <b-navbar-item
                    v-if="
                        $store.state.user.token &&
                        !$store.state.user.mobile_verified
                    "
                    tag="router-link"
                    :to="{ name: 'verify-mobile' }"
                >
                    <span class="font-apercu-bold">{{
                        $t("Verify mobile")
                    }}</span>
                </b-navbar-item>
                <b-navbar-item
                    v-if="
                        $store.state.user.token &&
                        !$store.state.user.email_verified
                    "
                    tag="router-link"
                    :to="{ name: 'verify' }"
                >
                    <span class="font-apercu-bold">
                        {{ $t("Please verify Email from your Email") }}
                    </span>
                </b-navbar-item>
                <template
                    v-if="
                        $store.state.user.token &&
                        $store.state.user.mobile_verified &&
                        $store.state.user.email_verified
                    "
                >
                    <b-navbar-item
                        tag="router-link"
                        :to="{ name: 'my-shipment' }"
                        :active="current == 'my-shipment'"
                    >
                        <span class="font-apercu">{{ $t("Orders") }}</span>
                    </b-navbar-item>
                    <b-navbar-item
                        class="SMOnly"
                        tag="router-link"
                        :to="{ name: 'add-credit' }"
                        :active="current == 'add-credit'"
                    >
                        <span class="font-apercu">{{ $t("My wallet") }}</span>
                    </b-navbar-item>
                    <b-navbar-item
                        class="LGOnly"
                        tag="router-link"
                        :to="{ name: 'my-addresses' }"
                        :active="current == 'my-addresses'"
                    >
                        <span class="font-apercu">{{
                            $t("Address Book")
                        }}</span>
                    </b-navbar-item>
                    <b-navbar-item class="LGOnly" tag="a">
                        <b-dropdown
                            v-if="$store.state.user.token"
                            aria-role="list"
                        >
                            <div class="pointer" slot="trigger">
                                <span slot="trigger" class="font-apercu">
                                    {{ $t("Financial") }}
                                </span>
                            </div>

                            <b-dropdown-item
                                aria-role="listitem"
                                @click="$router.push('/add-credit')"
                            >
                                <p class="font-apercu">
                                    {{ $t("My wallet") }}
                                </p>
                            </b-dropdown-item>
                            <!--
                            <b-dropdown-item
                                aria-role="listitem"
                                @click="
                                    $router.push({
                                        name: 'all-transactions',
                                    })
                                "
                            >
                                <p class="font-apercu">
                                    {{ $t("Transactions") }}
                                </p>
                            </b-dropdown-item>
                            -->
                            <b-dropdown-item
                                aria-role="listitem"
                                @click="$router.push({ name: 'invoices' })"
                            >
                                <p class="font-apercu">
                                    {{ $t("Invoices") }}
                                </p>
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-navbar-item>
                    <b-navbar-item
                        v-if="$route.name != 'homepage'"
                        tag="router-link"
                        :to="{ name: 'send-shipment' }"
                        :active="current == 'send-shipment'"
                    >
                        <span class="font-apercu">{{
                            $t("Send Shipment")
                        }}</span>
                    </b-navbar-item>
                    <b-navbar-item
                        v-if="$route.name != 'homepage'"
                        tag="a"
                        href="https://www.alkoonshipping.com/referral_program"
                        target="_blanck"
                        :active="current == 'send-shipment'"
                    >
                        <span class="font-apercu">{{ $t("Free credit") }}</span>
                    </b-navbar-item>
                    <b-navbar-item
                        v-if="$route.name != 'homepage'"
                        tag="a"
                        href="https://www.alkoonshipping.com/linkstore"
                        target="_blanck"
                        :active="current == 'send-shipment'"
                    >
                        <span class="font-apercu">{{ $t("Link store") }}</span>
                    </b-navbar-item>
                </template>
                <div v-if="!$store.state.user.token" :class="'showInSmallOnly'">
                    <b-navbar-item tag="li" @click="changeLang">
                        <span class="font-apercu-bold">{{
                            $i18n.locale == "en"
                                ? "التغيير إلي العربية"
                                : "Change to English"
                        }}</span>
                    </b-navbar-item>
                    <b-navbar-item
                        tag="router-link"
                        :to="{ name: 'sign-in-email' }"
                    >
                        <span class="font-apercu-bold">{{
                            $t("Sign In")
                        }}</span>
                    </b-navbar-item>
                    <b-navbar-item tag="router-link" :to="{ name: 'sign-up' }">
                        <span class="font-apercu-bold">{{
                            $t("Register")
                        }}</span>
                    </b-navbar-item>
                </div>

                <div v-if="$store.state.user.token" :class="'showInSmallOnly'">
                    <b-navbar-item tag="li" @click="changeLang">
                        <span class="font-apercu-bold">{{
                            $i18n.locale == "en"
                                ? "التغيير إلي العربية"
                                : "Change to English"
                        }}</span>
                    </b-navbar-item>
                    <b-navbar-item tag="li" @click="signOut">
                        <span class="font-apercu-bold">{{
                            $t("Sign-out")
                        }}</span>
                    </b-navbar-item>
                </div>

                <b-dropdown
                    class="locale"
                    v-if="$store.state.user.token"
                    aria-role="list"
                >
                    <div
                        class="pointer"
                        style="margin: 6px 10px 0; display: flex"
                        slot="trigger"
                        slot-scope="{ active }"
                    >
                        <b-icon
                            :icon="active ? 'menu-up' : 'menu-down'"
                        ></b-icon>
                        <inline-svg
                            style="margin-top: 3px"
                            :src="require('@/assets/images/globe.svg')"
                            :fill="
                                $route.name == 'homepage' ? 'white' : 'black'
                            "
                        ></inline-svg>
                        <span style="margin: 0 5px">
                            {{ $i18n.locale == "ar" ? "العربية" : "English" }}
                        </span>
                    </div>

                    <b-dropdown-item aria-role="listitem">
                        <p @click="changeLang">
                            <span>
                                {{
                                    $i18n.locale == "en"
                                        ? "التغيير إلي العربية"
                                        : "Change to English"
                                }}
                            </span>
                        </p>
                    </b-dropdown-item>
                </b-dropdown>
            </template>
        </b-navbar>

        <user-options v-if="$store.state.user.token"></user-options>
        <div
            v-if="!$store.state.user.token"
            class="register"
            style="display: flex; align-items: center"
        >
            <b-dropdown class="locale" aria-role="list">
                <div
                    class="pointer"
                    style="margin: 0 10px 0; display: flex; align-items: center"
                    slot="trigger"
                    slot-scope="{ active }"
                >
                    <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                    <inline-svg
                        style="margin-top: 3px"
                        :src="require('@/assets/images/globe.svg')"
                        :fill="$route.name == 'homepage' ? 'white' : 'black'"
                    ></inline-svg>
                </div>

                <b-dropdown-item aria-role="listitem">
                    <p @click="changeLang">
                        <span>
                            {{
                                $i18n.locale == "en"
                                    ? "التغيير إلي العربية"
                                    : "Change to English"
                            }}
                        </span>
                    </p>
                </b-dropdown-item>
            </b-dropdown>

            <b-navbar-item tag="router-link" :to="{ name: 'sign-in-email' }">
                <span class="font-apercu-bold">{{ $t("Sign In") }}</span>
            </b-navbar-item>
            <b-navbar-item tag="router-link" :to="{ name: 'sign-up' }">
                <span class="font-apercu-bold">{{ $t("Register") }}</span>
            </b-navbar-item>
        </div>
    </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";
import UserOptions from "./UserOptions.vue";

export default {
    components: {
        "user-options": UserOptions,
        InlineSvg,
    },
    data() {
        return {
            current: this.$route.name,
            hovered: false,
        };
    },
    computed: {
        user() {
            return this.$store.getters.userData;
        },
    },
    methods: {
        signOut() {
            this.$store.dispatch("logout").then(() => {
                this.$router.push({
                    name: "sign-in-email",
                });
            });
        },
        changeLang() {
            if (this.$i18n.locale == "en") {
                localStorage.setItem("lang", "ar");
            } else {
                localStorage.setItem("lang", "en");
            }
            location.reload();
        },
    },
};
</script>

<style lang="scss" scoped>
.locale {
    @media only screen and (max-width: 1000px) {
        display: none !important;
    }
}

.showInSmallOnly {
    display: none;

    @media only screen and (max-width: 1020px) {
        display: block;
    }
}

.register {
    width: 500px;

    @media only screen and (max-width: 1020px) {
        width: 0;
    }
}

.bg-black {
    background: black !important;
    color: white !important;

    a.navbar-item {
        color: white;
        border-radius: 5px !important;

        &:hover {
            color: #000;
        }
    }

    div.navbarItem {
        color: white !important;
    }

    @media only screen and (max-width: 1020px) {
        a.navbar-item {
            color: #000;
        }

        div.navbarItem {
            color: #000 !important;
        }
    }
}

.nav-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
    // position: fixed;
    // z-index: 100;
    // top: 0;
    // width: 100%;
    background: #fafafa;

    .navbar-brand {
        justify-content: space-between;
    }

    .account-type {
        background: white;
        border-radius: 50px;
        padding: 0 8px;
        left: 21%;
        font-size: 10px;

        &:lang(ar) {
            padding: 0 15px;
            left: 25%;
            font-size: 12px;
        }
    }
}

#custom-nav {
    .navbar-start {
        a.navbar-item {
            padding: 5px 15px;
            cursor: pointer;
            // color: #fefefe !important;
            // font-weight: bold;

            &:hover {
                background: white !important;
                border-radius: 10px;
                color: black !important;
            }
        }

        div.navbarItem {
            padding: 5px 15px;
            margin-left: 25px;
            cursor: pointer;
            position: relative;

            .options {
                transition: 0.5s;
                position: absolute;

                p {
                    // width: 100px;
                    // text-align: center;
                    &:hover {
                        background: white !important;
                        border-radius: 10px;
                        color: black !important;
                    }
                }
            }

            color: black; // font-weight: bold;
            // color: #fefefe !important;

            &:hover {
                background: white !important;
                border-radius: 10px;
                color: black !important;
            }

            &:last-of-type {
                padding: 5px 25px;
                background: white;
                border-radius: 10px;

                &:hover {
                    background: #4952ff !important;
                    color: white !important;
                }
            }
        }
    }
}

::v-deep {
    .navbar-brand {
        align-items: center;
        margin-bottom: 15px !important;
        justify-content: space-between;
    }

    .has-dropdown {
        margin-top: 0 !important;
    }

    a.navbar-burger.burger {
        margin: 0 20px !important;
    }

    .navbar,
    .navbar-menu,
    .navbar-start,
    .navbar-end {
        align-items: flex-start;
    }

    .navbar-start {
        margin-top: 10px;

        .navbar-item {
            color: black; // background: white;
            // height: 40px;
            // &:last-of-type {
            //     padding: 5px 25px;
            //     background: #f2f2f2;
            //     border-radius: 10px;
            //     &:hover {
            //         background: #4952ff !important;
            //         color: black !important;
            //     }
            // }
        }
    }
}

.logo {
    margin-left: 0 !important;
    align-items: flex-start !important;
}

.navbar {
    background-color: transparent;
    padding: 10px 0 0;
    width: 100%;
}

.navbar-item,
.navbar-link {
    margin-left: 25px;
}

.navbar-item {
    transition: 0.2s linear;
    color: black;

    // color: white;
    // font-weight: bold;

    // &:hover:not(.router-link-exact-active) {
    //     color: black !important;
    // }
}

.router-link-exact-active {
    color: black !important;
}
</style>
